<template>
  <div class="judges-progress container">
    <h2 style="font-weight:200;">Judges Progress</h2>
    <table class="table table-striped">
      <thead class>
        <tr>
          <th>name</th>
          <th>id</th>
          <th>viewed</th>
          <th>scored</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="judge in judges" :key="judge.uid">
          <td>{{judge.firstName+' '+judge.lastName}}</td>
          <td>{{judge.uid}}</td>
          <td>{{judgeViewedCount(judge.uid)}}</td>
          <td>{{judgeScoreCount(judge.uid)}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  data() {
    return {
      judges: [
        {
          uid: 'hA2HV3mUx2UOG2f7uNCPAw8nVNC3',
          firstName: 'Paul',
          lastName: 'Geraghty',
          email: 'paul@dot.ie'
        },
        {
          uid: 'slIqVUdlgiQFz3GXv8ElGvFSjbw1',
          firstName: 'Andreas',
          lastName: 'Müller-Pohle',
          email: 'mail@equivalence.com'
        },
        {
          uid: 'CKb1Xs6srjMd379EQFxxFLHpBfG3',
          firstName: 'Anna',
          lastName: 'Kućma',
          email: 'annakucma@gmail.com'
        },
        {
          uid: 'yqJgcRJsk7aRASkvny7yGkoMkZX2',
          firstName: 'Jeanne',
          lastName: 'Mercier',
          email: 'jane.iksat@gmail.com'
        },
        {
          uid: 'ZBCDlZlRhfRgGETEyx1DqkEwFxZ2',
          firstName: 'Simon',
          lastName: 'Bainbridge',
          email: 'simon@apptitudemedia.co.uk'
        },
        {
          uid: 'AN9ScJZwFfVhQwvey6qkXqUfHDd2',
          firstName: 'Joselina',
          lastName: 'Cruz',
          email: 'mja.cruz@gmail.com'
        },
        {
          uid: 'IjjJnKzJZXTjcvZ8F1X7otJYI623',
          firstName: 'Jürg',
          lastName: 'Schneider',
          email: 'juerg.schneider@unibas.ch'
        },
        {
          uid: 'MKlrj4wOzSRy9spukYvy1aDvd6i2',
          firstName: 'John',
          lastName: 'Fleetwood',
          email: 'johnf@phototool.co.za'
        },
        {
          uid: 'WlF7dP3V9dVUPQ3ji2VQ3gD82bC2',
          firstName: 'Azu',
          lastName: 'Nwagbogu',
          email: 'azu.n@africanartists.org'
        },
        {
          uid: 'yizYWQQgl6M7F2iLtcTX9M9pcYD3',
          firstName: 'Akinbode',
          lastName: 'Akinbiyi',
          email: 'akinbodeakinbiyi@gmx.net'
        },
        {
          uid: '66W8byIoOPd0O6L0N8AwM55HfFy1',
          firstName: 'Steven',
          lastName: 'Evans',
          email: 'director@fotofest.org'
        },
        {
          uid: 'gDSkvSLt6TXMMZ3HfMGdH1muONA3',
          firstName: 'Olfa',
          lastName: 'Feki',
          email: 'olfa.feki@gmail.com'
        },
        {
          uid: 'rXIIpbq4HuXll56vrdZozG160zh2',
          firstName: 'Anna-Alix',
          lastName: 'Koffi',
          email: 'offthewallcp@gmail.com'
        },
        {
          uid: 'McbUvRylsiVUT3AoJQvwmaXi9ms1',
          firstName: 'Uche',
          lastName: 'Okpa-Iroha',
          email: 'uche@tniacp.org.ng'
        },
        {
          uid: 'jaUrR8wUFzQkO3cRiucKXG1POQq1',
          firstName: 'Françoise',
          lastName: 'Callier',
          email: 'frcallier989@gmail.com'
        },
        {
          uid: 'YnfmQTwGEnXalHC1q6PaIDBMa7g2',
          firstName: 'Benjamin',
          lastName: 'Füglister',
          email: 'ben@capprize.com'
        },
        {
          uid: 'Q5FReGDP07YXonpUNDkb4BFb7Bx1',
          firstName: 'Tuula',
          lastName: 'Alajoki',
          email: 'tuula.alajoki@gmail.com'
        },
        {
          uid: '3IbYVxDCn1SGtxxgRUI43MZcpDJ2',
          firstName: 'Lekgetho',
          lastName: 'Makola',
          email: 'Jamito74@gmail.com'
        },
        {
          uid: 'PSptlZnKIrMZkOX38YYfQrT6I4e2',
          firstName: 'Wassim',
          lastName: 'Ghozlani',
          email: 'ghozlani.wassim@gmail.com'
        },
        {
          uid: 'Yhw1E12IhlhJo9qdx6i0BsVUFjk1',
          firstName: 'Aaron',
          lastName: 'Yebeoha',
          email: 'contact@africanlens.co'
        },
        {
          uid: '8awIKHiM40ZzDZF34cf67xCjTYy1',
          firstName: 'Yvon',
          lastName: 'Langué',
          email: 'yvonlangue@gmail.com'
        },
        {
          uid: 'ADbyzB6Yl3aUiQDttM4GbBiqA9G3',
          firstName: 'Tanya',
          lastName: 'Kiang',
          email: 'tanya@galleryofphotography.ie'
        },
        {
          uid: 'Wu82U6M9XHPWr9OjMRpG7xojtZj1',
          firstName: 'Landry',
          lastName: 'Mbassi',
          email: 'mbassilandry@gmail.com'
        },
        {
          uid: 'OAbpocQsmlfdrEL5jPHd4fqXqDk1',
          firstName: 'Bronwyn',
          lastName: 'Law-Viljoen',
          email: 'bronwyn@fourthwallbooks.com'
        }
      ]
    }
  },
  computed: {
    ...mapState({
      // entrants: state => state.admin.entrands
      entries: state => state.judging.entries,
      currentJudge: state => state.currentUser,
      allEntries: state => state.judging.allEntries
    }),
    ...mapGetters({
      // entries: 'review/filteredEntries',
      judgeScoreCount: 'judging/judgeScoreCount',
      allEntryArray: 'judging/allEntryArray',
      judgeViewedCount: 'judging/judgeViewedCount'
    })
  },
  mounted() {
    this.$store.dispatch('judging/getEntries')
  }
}
</script>

<style scoped>
</style>
